import { render, staticRenderFns } from "./board.vue?vue&type=template&id=3357298f"
import script from "./board.vue?vue&type=script&lang=ts"
export * from "./board.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports